<terra-button
    [inputIsSmall]="inputIsSmall"
    [inputIsLarge]="inputIsLarge"
    [inputIsDisabled]="inputIsDisabled"
    [inputCaption]="inputCaption"
    [inputIcon]="inputIcon"
    [inputType]="'button'"
    [inputIsAlignRight]="inputIsAlignRight"
    [inputTooltipText]="inputTooltipText"
    [inputTooltipPlacement]="inputTooltipPlacement"
    [inputIsActive]="inputIsActive"
    [inputIsFlagged]="inputIsFlagged"
    [inputIsDivider]="inputIsDivider"
    [inputIsLink]="inputIsLink"
    (outputClicked)="onClick($event)"
>
</terra-button>

<ng-template>
    <mat-dialog-content>
        <terra-file-browser
            #fileBrowser
            [inputAllowedExtensions]="inputAllowedExtensions"
            [inputAllowFolders]="inputAllowFolders"
            [inputStorageServices]="inputStorageServices"
            (outputSelectedChange)="onSelectedObjectChange($event)"
        >
        </terra-file-browser>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button
            mat-flat-button
            mat-dialog-close
            [disabled]="secondaryOverlayButton.isDisabled"
            (click)="secondaryOverlayButton.clickFunction()"
        >
            <mat-icon fontSet="plentyicons" [fontIcon]="secondaryOverlayButton.icon"></mat-icon>
            {{ inputSecondaryBrowserButtonCaption }}
        </button>
        <button
            mat-flat-button
            mat-dialog-close
            color="terra-color-active"
            [disabled]="primaryOverlayButton.isDisabled"
            (click)="primaryOverlayButton.clickFunction()"
        >
            <mat-icon fontSet="plentyicons" [fontIcon]="primaryOverlayButton.icon"></mat-icon>
            {{ inputPrimaryBrowserButtonCaption }}
        </button>
    </mat-dialog-actions>
</ng-template>
